export default {
    state: {
        companyInfo: {}
    },
    mutations: {
        setCompanyInfo(state, companyInfo) {
            state.companyInfo = companyInfo
        }
    },
    actions: {
        setCompanyInfo({commit}, companyInfo) {
            commit('setUserInfo', companyInfo)
        }
    }
}
